import get from "lodash/get";
import {
  getTransformedMinutes,
  checkNullable,
} from "../../../utilities/helpers";

const cardTitleBg = {
  1: "bg-green-700",
  2: "bg-red-700",
  3: "bg-orange-700",
};

const andonColumns = () => [
  {
    title: "Machine",
    dataIndex: "name",
    key: "name",
    width: 120,
    onCell: (record) => ({
      rowSpan: record.span ?? 0,
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    render: (value, record) => (
      <div
        className={`${cardTitleBg[get(record, "status.value")]} text-center`}
      >
        {value ?? "--"}
      </div>
    ),
  },
  {
    title: "Status",
    dataIndex: ["status", "name"],
    key: "status",
    width: 65,
    onCell: (record) => ({
      rowSpan: record.span ?? 0,
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    render: (value) => value ?? "--",
  },
  {
    title: (
      <div className="flex flex-col items-center justity-cent">
        <p className="text-center">Cycle time</p>
        <p>Target / Actual</p>
      </div>
    ),
    width: 120,
    key: "target_actual_cycle_tme",
    onCell: (record) => ({
      rowSpan: record.span ?? 0,
      style: { textAlign: "center" },
    }),
    render: (record) => {
      return get(record, "non_conf") ? (
        "NCONF"
      ) : (
        <p>
          {get(record, "meta.planned_cycle_time", "--")} /{" "}
          {get(record, "meta.avg_cycle_time", "--")}
        </p>
      );
    },

    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "MachEff",
    width: 75,
    dataIndex: ["meta", "machine_efficiency"],
    key: "machine_efficiency",
    onCell: (record) => ({
      rowSpan: record.span ?? 0,
      style: { textAlign: "center" },
    }),
    render: (value, record) =>
      get(record, "non_conf") ? "NCONF" : `${checkNullable(value, 0)}%`,
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "ProdEff",
    width: 70,
    dataIndex: ["meta", "product_efficiency"],
    key: "product_efficiency",
    onCell: (record) => ({
      rowSpan: record.span ?? 0,
      style: { textAlign: "center" },
    }),
    render: (value, record) =>
      get(record, "non_conf")
        ? "NCONF"
        : value
          ? `${checkNullable(value, 0)}%`
          : "--",
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "OEE",
    dataIndex: ["meta", "oee"],
    key: "oee",
    onCell: (record) => ({
      rowSpan: record.span ?? 0,
      style: { textAlign: "center" },
    }),
    render: (value, record) =>
      get(record, "non_conf") ? "NCONF" : (checkNullable(value, 0) ?? "--"),

    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "Part",
    dataIndex: ["part", "name"],
    width: 180,
    key: "part",
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
    render: (value) => value ?? "--",
  },
  {
    title: "Target",
    key: "target",
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    render: (record) =>
      get(record, "part.count.target_count") ||
      get(record, "part.length.target_length") ||
      0,

    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "Actual",
    key: "count",
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    render: (record) =>
      get(record, "part.count.actual") ||
      get(record, "part.length.actual") ||
      0,

    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "Rej Pc",
    key: "rejected",
    render: (record) =>
      get(record, "part.count.rejected") ||
      get(record, "part.length.rejected") ||
      0,
    onCell: (record) => ({
      style: { textAlign: "center" },
    }),
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "Expected / Diff",
    key: "rejected",
    width: 100,
    onCell: () => ({
      style: { textAlign: "center" },
    }),
    render: (record) => {
      return (
        <div
          className="text-center"
          style={{
            background: `${
              (get(record, "part.count.count_difference") ||
                get(record, "part.length.length_difference")) < 0
                ? "#A02020"
                : "#008141"
            }`,
          }}
        >
          <span>
            {get(record, "part.count.estimated_count") ||
              get(record, "part.length.estimated_length") ||
              0}
          </span>
          <span className="text-xs">
            /{" "}
            {checkNullable(
              get(record, "part.count.count_difference") ||
                get(record, "part.length.length_difference"),
              0,
            ) || 0}
          </span>
        </div>
      );
    },
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },

  {
    title: "On",
    key: "time",
    onCell: (record) => ({
      rowSpan: record.span ?? 0,
      style: { textAlign: "center" },
    }),
    render: (record) => {
      return `${getTransformedMinutes(get(record, "on_time", 0)) || 0}`;
    },
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "OFF",
    key: "time",
    onCell: (record) => ({
      rowSpan: record.span ?? 0,
      style: { textAlign: "center" },
    }),
    render: (record) => {
      return ` ${getTransformedMinutes(get(record, "off_time", 0)) || 0} `;
    },
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "IDLE",
    key: "time",
    onCell: (record) => ({
      rowSpan: record.span ?? 0,
      style: { textAlign: "center" },
    }),
    render: (record) => {
      return `${getTransformedMinutes(get(record, "idle_time", 0)) || 0}`;
    },
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
  {
    title: "KWH",
    key: "power",
    onCell: (record) => ({
      rowSpan: record.span ?? 0,
      style: { textAlign: "center" },
    }),
    render: (record) => {
      return `${get(record, "total_power", 0) || 0} Kwh`;
    },
    onHeaderCell: () => ({
      style: {
        textAlign: "center",
      },
    }),
  },
];

export default andonColumns;
